import React from "react";
import { Tab as MuiTab, Tabs as MuiTabs, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    // backgroundColor: "#fff",
    borderBottomWidth: 1,
    borderBottomColor: theme.palette.grey[300],
    borderBottomStyle: "solid",
    marginBottom: 15,
  },
  tab: {
    //textTransform: "none",
    marginRight: theme.spacing(1),
  },
  indicator: {
    display: "flex",
    justifyContent: "center",
    "& > span": {
      width: "100%",
    },
  },
}));

export type TabsProps = {
  tabs: { id: string; label: React.ReactNode; dataTest?: string }[];
  currentTabId: string;
  onTabChange: (newId: string) => void;
  dataTest?: string;
  indicatorColor?: string;
  textColor?: string;
};

export const Tabs: React.FC<TabsProps> = ({
  tabs,
  currentTabId,
  onTabChange,
  dataTest,
  indicatorColor,
  textColor,
}) => {
  const classes = useStyles();
  return (
    <MuiTabs
      data-test={dataTest}
      value={currentTabId}
      onChange={(_, newTabId) => onTabChange(newTabId)}
      indicatorColor="secondary"
      textColor="secondary"
      className={classes.root}
      TabIndicatorProps={{
        children: <span />,
        className: classes.indicator,
        style: {
          backgroundColor: `${indicatorColor && indicatorColor}`,
        },
      }}
      scrollButtons="auto"
      variant="scrollable"
    >
      {tabs.map((tab, index) => (
        <MuiTab
          className={classes.tab}
          key={tab.id}
          value={tab.id}
          label={
            <span style={{ color: `${textColor && textColor}` }}>
              {tab.label}
            </span>
          }
          data-test={tab.dataTest || `tab-${index}`}
          selected={tab.id === currentTabId}
        ></MuiTab>
      ))}
    </MuiTabs>
  );
};
